import { render, staticRenderFns } from "./PricesView.vue?vue&type=template&id=0932081e&scoped=true"
import script from "./PricesView.vue?vue&type=script&lang=ts"
export * from "./PricesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0932081e",
  null
  
)

export default component.exports